export default __webpack_public_path__ + "static/media/pkv.97da559e.png";